export const COMPONENT_NAME = 'DayHighlight';
